"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("../../../../../../components/PageGrid/templates/Grid/Grid"));

var _GridItem = _interopRequireDefault(require("../../../../../../components/PageGrid/templates/GridItem/GridItem"));

var _Icon = _interopRequireDefault(require("../../../../../../components/PageGrid/atoms/Icon/Icon"));

// atoms
var Image = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/atoms/Image/Image"));
  });
});
var Video = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/atoms/Video/Video"));
  });
}); // molecules

var Typography = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/Typography/Typography"));
  });
});
var ButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/ButtonDownload/ButtonDownload"));
  });
});
var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
}); // organisms

var Accordion = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/Accordion/Accordion"));
  });
});
var ActionCardContainer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/ActionCardContainer/ActionCardContainer"));
  });
});
var AudioPlayer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/AudioPlayer/AudioPlayer"));
  });
});
var Card = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/Card/Card"));
  });
});
var GridList = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/GridList/GridList"));
  });
});
var List = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/List/List"));
  });
});
var ListDropdown = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/ListDropdown/ListDropdown"));
  });
});
var MusicCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/MusicCard/MusicCard"));
  });
});
var ReviewCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/ReviewCard/ReviewCard"));
  });
});
var PostCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/PostCard/PostCard"));
  });
});
var PricingCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/PricingCard/PricingCard"));
  });
});
var StyledList = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/organisms/StyledList/StyledList"));
  });
}); // templates

var ButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/ButtonDialog/ButtonDialog"));
  });
});
var ButtonDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/ButtonDrawer/ButtonDrawer"));
  });
});
var Form = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/Form/Form"));
  });
});
var IconButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/IconButtonDialog/IconButtonDialog"));
  });
});
var IconButtonDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/IconButtonDrawer/IconButtonDrawer"));
  });
});
var components = {
  Icon: _Icon.default,
  Image: Image,
  Video: Video,
  Typography: Typography,
  ButtonDownload: ButtonDownload,
  ButtonDrawer: ButtonDrawer,
  Form: Form,
  ButtonRedirect: ButtonRedirect,
  IconButtonDownload: IconButtonDownload,
  IconButtonRedirect: IconButtonRedirect,
  Accordion: Accordion,
  ActionCardContainer: ActionCardContainer,
  AudioPlayer: AudioPlayer,
  Card: Card,
  GridList: GridList,
  List: List,
  ListDropdown: ListDropdown,
  MusicCard: MusicCard,
  ReviewCard: ReviewCard,
  PostCard: PostCard,
  PricingCard: PricingCard,
  StyledList: StyledList,
  ButtonDialog: ButtonDialog,
  IconButtonDialog: IconButtonDialog,
  IconButtonDrawer: IconButtonDrawer,
  MobileTabGridItem: _GridItem.default
};

var MobileTab = function MobileTab(_ref) {
  var tab = _ref.tab;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, tab, {
    components: components
  })));
};

var _default = MobileTab;
exports.default = _default;
MobileTab.propTypes = {
  /** State you would like to show if user is in this state */
  geocodeState: _propTypes.default.string,

  /** props to spread to  */
  tab: _propTypes.default.shape.isRequired
};
MobileTab.defaultProps = {
  geocodeState: ''
};